import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from '../config/config.service';
import { ICustomerAppsConfig } from '../config/config.module';
import { localeMapping } from './locale-mapping';

@Injectable()
export class ApiUserLanguageInterceptor implements HttpInterceptor {
  constructor(
    @Inject(LOCALE_ID) private userLocaleId: string,
    private configService: ConfigService<ICustomerAppsConfig>,
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const requestUrl = request.url;
    const normalizedRequestUrl = requestUrl.replace(/^\/app_dev\.php(.*)/, '$1');
    const isApiUrl =
      requestUrl.startsWith(this.configService.config.apiUrl) ||
      requestUrl.startsWith(this.configService.config.apiPath) ||
      normalizedRequestUrl.startsWith(this.configService.config.apiUrl) ||
      normalizedRequestUrl.startsWith(this.configService.config.apiPath);

    if (isApiUrl && !request.params.has('lang')) {
      request = request.clone({
        params: request.params.set('lang', localeMapping[this.userLocaleId]),
      });
    }

    return next.handle(request);
  }
}
